import { useEffect, useState } from "react";
import { handleSpringDataRequest } from "../../../../api";
import useAccessControl from "../../../../../hooks/useAccessControl";
import { GLOBAL_FEATURES } from "../../../../Utils/CONST";
import { useSelector } from "react-redux";
import moment from "moment-timezone";

const useAllowPastBookingCreation = (checkIn) => {
  const checkInMs =
    checkIn?.toString().length === 10 ? checkIn * 1000 : checkIn;
  const { canRead } = useAccessControl();
  const hotelTimeZone = useSelector(
    (state) => state?.auth?.selectedHotel?.hotelTimeZone
  );

  const hasPermissionToCreatePastBooking = canRead(
    GLOBAL_FEATURES.PastDateCreateBooking
  );
  const [allowPastDatesBookingCreation, setAllowPastDatesBookingCreation] =
    useState(canRead(GLOBAL_FEATURES.PastDateCreateBooking));
  const [isLoading, setIsLoading] = useState(false);
  const [isNightAuditEnabled, setIsNightAuditEnabled] = useState(false);

  useEffect(() => {
    if (!checkInMs) return;
    if (hasPermissionToCreatePastBooking) return;

    setIsLoading(true);

    handleSpringDataRequest(
      `core/api/v1/nightAuditConfig/get-night-audit-configuration`
    )
      .then((res) => {
        const todaysEpoch = moment().tz(hotelTimeZone).startOf("day").valueOf();
        if ("enable" === res?.status?.toLowerCase()) {
          setIsNightAuditEnabled(true);

          const now = moment().tz(hotelTimeZone);
          const startDate = now.clone().subtract(1, "day").format("DD-MM-YYYY");
          const endDate = now.format("DD-MM-YYYY");

          handleSpringDataRequest(
            `core/api/v1/nightAuditTracker/get-range-night-audit-tracker?endRange=${endDate}&startRange=${startDate}`
          ).then((auditRes) => {
            const yesterday = now.clone().subtract(1, "day").startOf("day");

            const hasSuccessForYesterday = (auditRes ?? []).some((audit) => {
              const auditDate = moment
                .tz(audit.audit_date, "DD MMM YYYY hh:mm A", hotelTimeZone)
                .startOf("day");

              return (
                auditDate.isSame(yesterday, "day") &&
                audit.night_audit_status === "SUCCESS"
              );
            });

            if (hasSuccessForYesterday && checkInMs < todaysEpoch) {
              setAllowPastDatesBookingCreation(false);
            } else if (checkInMs < yesterday.valueOf()) {
              setAllowPastDatesBookingCreation(false);
            } else {
              setAllowPastDatesBookingCreation(true);
            }
          });
        } else {
          if (checkInMs < todaysEpoch) {
            console.log(
              "abhishek booking for previous date: ",
              checkInMs,
              todaysEpoch
            );
            setAllowPastDatesBookingCreation(false);
          } else {
            setAllowPastDatesBookingCreation(true);
          }
        }
      })
      .catch((err) => console.error("error occurred: ", err))
      .finally(() => setIsLoading(false));
  }, [hasPermissionToCreatePastBooking, hotelTimeZone, checkInMs]);
  console.log(
    "abhishek allow past bookings: ",
    allowPastDatesBookingCreation,
    isNightAuditEnabled
  );
  return {
    allowPastDatesBookingCreation,
    isLoading,
    isNightAuditEnabled,
  };
};

export default useAllowPastBookingCreation;
